import type { MedicalTestProfile } from "@cabocheck/shared";
import { useTranslation } from "react-i18next";
import { PublicProductCard } from "~/features/products/PublicProductCard";
import { notEmpty } from "~/utils/array";
import { highlightText } from "~/utils/highlightText";

export function MedicalTestProfileBox({
  panel,
  to,
  search,
}: {
  panel: Pick<MedicalTestProfile, "name" | "subline" | "selling_price" | "medical_tests" | "medical_test_parameters">;
  to: string;
  search?: string;
}) {
  const { t } = useTranslation();
  const specimen_type = panel.medical_tests.at(0)?.specimen_type ?? "BLOOD";
  const description = panel.subline || panel.medical_test_parameters?.map((parameter) => parameter.name).join(", ");

  const parameter_faqs = panel.medical_test_parameters?.flatMap((parameter) => parameter.faqs).filter(notEmpty);
  const first_faq_with_search = search
    ? parameter_faqs?.find(
        (faq) =>
          faq.question.toLowerCase().includes(search.toLowerCase()) ||
          faq.response.toLowerCase().includes(search.toLowerCase()),
      )
    : undefined;

  return (
    <PublicProductCard
      name={panel.name}
      description={description}
      specimenType={specimen_type}
      sellingPrice={panel.selling_price}
      to={to}
      extraContent={
        first_faq_with_search ? (
          <>
            <h5 className="font-semibold">{t("Fragen und Antworten")}:</h5>
            <p className="text-gray-600">
              {highlightText({
                content: first_faq_with_search.question + " " + first_faq_with_search.response,
                highlight: search,
              })}
            </p>
          </>
        ) : undefined
      }
    />
  );
}
